module.exports = __webpack_public_path__ + "img/plane.7897050c.svg";